import { render, staticRenderFns } from "./yesCheckbox.vue?vue&type=template&id=1161b4c2"
import script from "./yesCheckbox.vue?vue&type=script&lang=js"
export * from "./yesCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports